import i18n from '@/locales/index'
const { t } = i18n.global
function arrayToMap (array=[], key, value) {
  const obj = {}
  for (let item of array) {
    obj[item[key]] = item[value]
  }
  return obj
}
const robotStatusMap = {
  1: t('bi.robot.running'),
  2: t('bi.robot.paused'),
  3: t('bi.robot.fault'),
  4: t('bi.robot.alarm'),
  5: t('common.constant.offline'),
  6: t('bi.robot.idle'),
  7: t('common.constant.notConnectedToOTA')
}

const statusList = [
  {
    id: 1,
    label: 'run',
    name: t('bi.robot.running')
  },
  {
    id: 2,
    label: 'stop',
    name: t('bi.robot.paused')
  },
  {
    id: 3,
    label: 'error',
    name: t('bi.robot.fault')
  },
  {
    id: 4,
    label: 'warn',
    name: t('bi.robot.alarm')
  },
  {
    id: 5,
    label: 'offline',
    name: t('common.constant.offline')
  },
  {
    id: 6,
    label: 'free',
    name: t('bi.robot.idle')
  }
  // {
  //   id: 'not_in_ota',
  //   name: '未接入OTA'
  // }
]
const verifyStatusList = [
  { name: t('common.constant.pendingReview'), value: 0 },
  { name: t('common.constant.reviewApproved'), value: 1 },
  { name: t('common.constant.reviewRejected'), value: 2 },
  { name: t('common.constant.noProcessingRequired'), value: 3 },
]

const verifyStatusMap = {
  0: t('common.constant.pendingReview'),
  1: t('common.constant.reviewApproved'),
  2: t('common.constant.reviewRejected'),
  3: t('common.constant.noProcessingRequired'),
}

const packetStatusList = [
  { name: t('common.constant.receive'), value: 1 },
  { name: t('common.constant.redPacketOpening'), value: 2 },
  { name: t('common.constant.pendingIssuance'), value: 3 },
  { name: t('common.constant.issued'), value: 4 },
  { name: t('common.constant.distributionFailed'), value: 5 },
  { name: t('common.constant.distributionSuccessful'), value: 6 },
  { name: t('common.constant.close'), value: 7 },
]
const packetStatusMap = {
  1: t('common.constant.receive'), 
  2: t('common.constant.redPacketOpening'), 
  3: t('common.constant.pendingIssuance'), 
  4: t('common.constant.issued'),
  5: t('common.constant.distributionFailed'), 
  6: t('common.constant.distributionSuccessful'),
  7: t('common.constant.close')
}

// 用户状态
const userTypesList = [
  { name: t('points.detail.internalUser'), value: 1 },
  { name: t('points.detail.regularUser'), value: 0 },
  { name: t('common.constant.iAmIntegrator'), value: 2 },
  { name: t('common.constant.iAmRobotUser'), value: 3 },
  { name: t('common.constant.iAmDistributor'), value: 4 },
  { name: t('common.constant.iAmEndCustomer'), value: 5 },
  { name: t('other.visitor.other'), value: 6 },
]
const userTypesMap = arrayToMap(userTypesList, 'value', 'name')

// 用户状态
const userStatusList = [
  { name: t('common.constant.normal'), value: 1 },
  { name: t('system.user.disable'), value: 100 },
]
const userStatusMap = arrayToMap(userStatusList, 'value', 'name')

// 注册渠道
const registerWayList = [
  { name: t('common.constant.miniProgram'), value: 0 },
  { name: t('common.constant.officialWebsite'), value: 1 },
  { name: t('common.constant.manualAddition'), value: 2 },
]
const registerWayMap = arrayToMap(registerWayList, 'value', 'name')

// 升级状态
const otaUpgradeList = [
  { label: t('process.cloningrecord.notStarted'), value: 0 },
  { label: t('error.errorlog.waitingForRobotResponse'), value: 1 },
  { label: t('common.constant.upgrading'), value: 2 },
  { label: t('common.constant.upgradeCompleted'), value: 3 },
  { label: t('common.constant.upgradeFailed'), value: 4 },
]
const otaUpgradeMap = arrayToMap(otaUpgradeList, 'value', 'label')

// 操作类型
const businessTypeList = [
  {name: '其他', value: 0},
  {name: '新增', value: 1},
  {name: '修改', value: 2},
  {name: '删除', value: 3},
  {name: '查询', value: 11},
  {name: '授权', value: 4},
  {name: '导出', value: 5},
  {name: '导入', value: 6},
  {name: '强退', value: 7},
  {name: '生成代码', value: 8},
  {name: '清空数据', value: 9},
  {name: '下载', value: 10},
  {name: '上传', value: 12}

]
const businessTypeListMap = arrayToMap(businessTypeList, 'value', 'name')

const userList = [
  {name: '登录OTA后台', value: 0},
  {name: '退出登录', value: 1},
  {name: '登录小程序', value: 2}
]
const userListMap = arrayToMap(userList, 'value', 'name')

const taskCategoryList = [
  // { label: t('eIoT.transmit.all'), value: 0 },
  { label: 'Assembly', value: 1 },
  { label: 'Grasping', value: 2 },
  { label: 'Insertion', value: 3 },
  { label: 'Routing', value: 4 },
  { label: 'Inspection', value: 5 },
  { label: 'Sorting', value: 6 },
  { label: 'Manipulation', value: 7 },
]

const taskCategoryListMap = arrayToMap(taskCategoryList, 'value', 'label')

const dataUsageTypeList = [
  // { label: t('eIoT.transmit.all'), value: 0, color: 'info' },
  { label: 'VLA', value: 1, color: '' },
  { label: 'VLM', value: 2, color: 'success' },
  { label: 'RL', value: 3, color: 'warning' },
  { label: 'AGENT', value: 4, color: 'danger' },
]

const dataUsageTypeListMap = arrayToMap(dataUsageTypeList, 'value', 'label')
const dataUsageTypeListColorMap = arrayToMap(dataUsageTypeList, 'value', 'color')


const endEffectorList = [
  // { label: t('eIoT.transmit.all'), value: 0 },
  { label: t('eIoT.transmit.gripper'), value: 1 },
  { label: t('eIoT.transmit.suctionCup'), value: 2 },
  { label: t('eIoT.transmit.twoFingerHand'), value: 3 },
  { label: t('eIoT.transmit.threeFingerHand'), value: 4 },
  { label: t('eIoT.transmit.fourFingerHand'), value: 5 },
  { label: t('eIoT.transmit.fiveFingerHand'), value: 6 },
  { label: t('eIoT.transmit.weldingGun'), value: 7 },
]
const endEffectorListMap = arrayToMap(endEffectorList, 'value', 'label')

const standard = false
export {
  arrayToMap,
  robotStatusMap,
  statusList,
  verifyStatusList,
  verifyStatusMap,
  packetStatusList,
  packetStatusMap,
  userTypesList,
  userTypesMap,
  userStatusList,
  userStatusMap,
  registerWayList,
  registerWayMap,
  otaUpgradeList,
  otaUpgradeMap,
  standard,
  businessTypeList,
  businessTypeListMap,
  userList,
  userListMap,
  taskCategoryList,
  taskCategoryListMap,
  dataUsageTypeList,
  dataUsageTypeListMap,
  endEffectorList,
  endEffectorListMap,
  dataUsageTypeListColorMap
}